<template>
    <div class="container text-center my-4">
      <h2>Confirm Birthdate and Terms</h2>
      <input v-model="birthDate" type="date" class="form-control my-3" placeholder="Fecha de Nacimiento" />
      <div class="form-check my-2">
        <input v-model="acceptTerms" type="checkbox" class="form-check-input" id="terms" />
        <label class="form-check-label" for="terms">
          Acepto los términos y condiciones
        </label>
      </div>
      <button class="btn btn-primary" @click="validateForm">Aceptar</button>
      <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        birthDate: '',
        acceptTerms: false,
        errorMessage: '',
      };
    },
    methods: {
      validateForm() {
        if (!this.birthDate) {
          this.errorMessage = 'Debes ingresar tu fecha de nacimiento.';
        } else if (!this.acceptTerms) {
          this.errorMessage = 'Debes aceptar los términos y condiciones.';
        } else {
          this.$router.push('/welcome-new-experience');
        }
      },
    },
  };
  </script>
  